export default __webpack_public_path__ + "static/media/cif-ch.30437036.svg";